import { Col, Row } from "antd";
import { SmileOutlined } from "@ant-design/icons";

const GrafanaWarning = ({ showOnlyIcon }) => {
  return (
    <Row justify="center" className="w100 flex-center">
      <Col span={24} className="text-center">
        <div>
          <SmileOutlined className="icon-font32 mb05 text-center" style={{color: "#667085"}} />
        </div>
        {!showOnlyIcon && (
          <>
            <div className="grey f13">Data Not Found</div>
          </>
        )}
      </Col>
    </Row>
  );
};

export default GrafanaWarning;
